(function () {
  const storageKey = 'esim-globals-recently-viewed';
  const maximumProducts = 10;

  function readProducts() {
    try {
      const products = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(products) ? products : [];
    } catch (error) {
      return [];
    }
  }

  function saveProduct(product) {
    if (!product || !product.handle || !product.title || !product.url) return;

    const products = readProducts().filter((item) => item.handle !== product.handle);
    products.unshift(product);

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(products.slice(0, maximumProducts)));
    } catch (error) {
      return;
    }
  }

  function createProductCard(product, buttonLabel) {
    const card = document.createElement('article');
    card.className = 'recently-viewed__card';

    const imageLink = document.createElement('a');
    imageLink.className = 'recently-viewed__image-link';
    imageLink.href = product.url;

    if (product.image) {
      const image = document.createElement('img');
      image.className = 'recently-viewed__image';
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 720;
      image.height = 480;
      imageLink.appendChild(image);
    }

    const content = document.createElement('div');
    content.className = 'recently-viewed__content';

    const title = document.createElement('a');
    title.className = 'recently-viewed__product-title';
    title.href = product.url;
    title.textContent = product.title;

    const button = document.createElement('a');
    button.className = 'recently-viewed__button';
    button.href = product.url;

    const buttonText = document.createElement('span');
    buttonText.textContent = buttonLabel;
    const buttonArrow = document.createElement('span');
    buttonArrow.className = 'recently-viewed__button-arrow';
    buttonArrow.setAttribute('aria-hidden', 'true');
    buttonArrow.textContent = '→';
    button.append(buttonText, buttonArrow);

    content.append(title, button);
    card.append(imageLink, content);
    return card;
  }

  async function getLocalizedProduct(product, rootUrl) {
    const normalizedRootUrl = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;

    try {
      const response = await fetch(`${normalizedRootUrl}products/${encodeURIComponent(product.handle)}.js`);
      if (!response.ok) return product;

      const localizedProduct = await response.json();
      return {
        handle: product.handle,
        title: localizedProduct.title || product.title,
        url: `${normalizedRootUrl}products/${product.handle}`,
        image: localizedProduct.featured_image || product.image
      };
    } catch (error) {
      return product;
    }
  }

  async function renderSection(section) {
    const track = section.querySelector('[data-recently-viewed-track]');
    if (!track) return;

    const products = readProducts().slice(0, maximumProducts);
    if (!products.length) return;

    const buttonLabel = section.dataset.buttonLabel || '商品を見る';
    const localizedProducts = await Promise.all(
      products.map((product) => getLocalizedProduct(product, section.dataset.rootUrl || '/'))
    );
    localizedProducts.forEach((product) => track.appendChild(createProductCard(product, buttonLabel)));
    section.hidden = false;

    const controls = section.querySelector('.recently-viewed__controls');
    const navigationButtons = section.querySelectorAll('[data-recently-viewed-direction]');

    function updateNavigation() {
      const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const previousButton = section.querySelector('[data-recently-viewed-direction="previous"]');
      const nextButton = section.querySelector('[data-recently-viewed-direction="next"]');

      if (controls) controls.hidden = maximumScroll <= 1;
      if (previousButton) previousButton.disabled = track.scrollLeft <= 1;
      if (nextButton) nextButton.disabled = track.scrollLeft >= maximumScroll - 1;
    }

    navigationButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.recentlyViewedDirection === 'next' ? 1 : -1;
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      });
    });

    track.addEventListener('scroll', updateNavigation, { passive: true });
    window.addEventListener('resize', updateNavigation);
    updateNavigation();
  }

  function initialize() {
    const productData = document.querySelector('[data-recently-viewed-product]');
    if (productData) {
      try {
        saveProduct(JSON.parse(productData.textContent));
      } catch (error) {
      }
    }

    document.querySelectorAll('[data-recently-viewed]').forEach(renderSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
